import React, {useState} from 'react';

const GENERATORS = {
    tgle: {
        name: 'The Grand Lounge Elite',
        description: 'Firma institucional TGLE — Oficial y Compacta',
        icon: 'fa fa-envelope',
        path: '/tools/outlook-signatures/tgle.html'
    },
    alcero: {
        name: 'CEDIS by ALCERO',
        description: 'Firma institucional para CEDIS / ALCERO',
        icon: 'fa fa-building',
        path: '/tools/outlook-signatures/alcero.html'
    }
};

const OutlookSignatures = () => {
    const [selectedGenerator, setSelectedGenerator] = useState('tgle');

    const generator = GENERATORS[selectedGenerator];

    return (
        <div className="container-fluid main-container">
            <div
                style={{
                    width: '100%',
                    margin: '0 auto',
                    paddingBottom: '40px'
                }}
            >
                <div
                    style={{
                        marginBottom: '20px',
                        borderBottom: '1px solid #e5e5e5',
                        paddingBottom: '16px'
                    }}
                >
                    <h2 style={{marginTop: 0, marginBottom: '6px'}}>
                        Firmas Institucionales Outlook
                    </h2>

                    <p
                        className="text-muted"
                        style={{marginBottom: 0}}
                    >
                        Generación controlada de firmas de correo para
                        colaboradores.
                    </p>
                </div>

                <div
                    className="row"
                    style={{marginBottom: '20px'}}
                >
                    {Object.keys(GENERATORS).map(key => {
                        const item = GENERATORS[key];
                        const active = selectedGenerator === key;

                        return (
                            <div
                                className="col-md-6"
                                key={key}
                                style={{marginBottom: '10px'}}
                            >
                                <button
                                    type="button"
                                    onClick={() => setSelectedGenerator(key)}
                                    style={{
                                        width: '100%',
                                        minHeight: '94px',
                                        padding: '15px 18px',
                                        borderRadius: '8px',
                                        border: active
                                            ? '2px solid #337ab7'
                                            : '1px solid #d9d9d9',
                                        background: active
                                            ? '#eef5fb'
                                            : '#ffffff',
                                        textAlign: 'left',
                                        cursor: 'pointer',
                                        boxShadow: active
                                            ? '0 2px 8px rgba(51, 122, 183, 0.18)'
                                            : '0 1px 4px rgba(0, 0, 0, 0.06)',
                                        transition: 'all 0.15s ease'
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: '52px',
                                                height: '52px',
                                                borderRadius: '50%',
                                                background: active
                                                    ? '#337ab7'
                                                    : '#6c757d',
                                                color: '#ffffff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0,
                                                marginRight: '15px'
                                            }}
                                        >
                                            <i
                                                className={item.icon}
                                                style={{fontSize: '22px'}}
                                            />
                                        </div>

                                        <div>
                                            <div
                                                style={{
                                                    fontSize: '17px',
                                                    fontWeight: 600,
                                                    color: '#333333',
                                                    marginBottom: '4px'
                                                }}
                                            >
                                                {item.name}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: '13px',
                                                    color: '#777777'
                                                }}
                                            >
                                                {item.description}
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        );
                    })}
                </div>

                <div
                    className="panel panel-default"
                    style={{
                        borderRadius: '8px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
                    }}
                >
                    <div
                        className="panel-heading"
                        style={{
                            background: '#f8f9fb',
                            padding: '13px 18px'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <strong>
                                <i
                                    className={generator.icon}
                                    style={{marginRight: '9px'}}
                                />
                                {generator.name}
                            </strong>

                            <span
                                className="text-muted"
                                style={{fontSize: '12px'}}
                            >
                                Generador institucional
                            </span>
                        </div>
                    </div>

                    <div
                        className="panel-body"
                        style={{
                            padding: 0,
                            background: '#ffffff'
                        }}
                    >
                        <iframe
                            key={selectedGenerator}
                            title={`Generador de firma ${generator.name}`}
                            src={`${process.env.PUBLIC_URL}${generator.path}`}
                            style={{
                                display: 'block',
                                width: '100%',
                                height: selectedGenerator === 'alcero'
                                    ? '1050px'
                                    : '900px',
                                border: 0,
                                background: '#ffffff'
                            }}
                            allow="clipboard-write"
                        />
                    </div>
                </div>

                <div
                    className="alert alert-info"
                    style={{marginTop: '18px', marginBottom: 0}}
                >
                    <i
                        className="fa fa-lock"
                        style={{marginRight: '8px'}}
                    />
                    Herramienta de uso interno para el equipo de Tecnología.
                    Las firmas generadas deben validarse antes de ser
                    instaladas en Outlook.
                </div>
            </div>
        </div>
    );
};

export default OutlookSignatures;
